import { render, staticRenderFns } from "./ETabelaAlunosEmRisco.vue?vue&type=template&id=48b1fd1a&scoped=true"
import script from "./ETabelaAlunosEmRisco.vue?vue&type=script&lang=js"
export * from "./ETabelaAlunosEmRisco.vue?vue&type=script&lang=js"
import style0 from "./ETabelaAlunosEmRisco.vue?vue&type=style&index=0&id=48b1fd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1fd1a",
  null
  
)

export default component.exports